import {Component, OnInit} from '@angular/core';
import {NgbModal, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {AdminService} from '../../../../../services/admin.service';
import {SpecializationsService} from "../../services/specializations.service";
import {HttpStatus, ValidationRules, NO_POSITION, VALIDATION_PATTERN} from '../../constants/specializations.constants';

@Component({
  selector: 'app-add-new-group',
  templateUrl: './add-new-group.component.html',
  styleUrls: ['./add-new-group.component.css']
})
export class AddNewGroupComponent implements OnInit {

  isAddBtnDisabled = true;
  specGroupName = '';
  operationSuccess = false;
  operationFail = false;
  isLoaded = false;
  noPositions = false;
  getPositionsError = false;
  inProgress = false;


  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private adminService: AdminService,
    public specializationsServ: SpecializationsService
  ) {
  }

  ngOnInit() {
    this.getPositions();
  }

  checkInput(value) {
    this.specGroupName = value;
    if (value.trim() === '' || value.trim() === undefined || value.trim().length < ValidationRules.MIN_NAME_LENGTH || value.startsWith(' ') || value.endsWith(' ') || !VALIDATION_PATTERN.test(value)) {
      this.isAddBtnDisabled = true;
    } else {
      this.isAddBtnDisabled = false;
    }
  }

  closeAlert() {
    this.operationSuccess = false;
    this.operationFail = false;
  }

  getPositions() {
    if (this.specializationsServ.positions.length) {
      this.isLoaded = true;
      return;
    }
    this.fetchPositionsFromServer();
  }

  private fetchPositionsFromServer() {
    this.adminService.getActivePositions().subscribe(
      (res: any) => this.handlePositionsSuccess(res),
      (err) => this.handlePositionsError(err)
    );
  }

  private handlePositionsSuccess(res: any) {
    this.specializationsServ.positions = res.body;
    this.isLoaded = true;
    if (res.status === HttpStatus.OK) {
      this.selectPosition(this.specializationsServ.positions[0]);
    } else if (res.status === HttpStatus.NO_CONTENT) {
      this.noPositions = true;
      this.selectPosition(NO_POSITION);
    }
  }

  private handlePositionsError(err) {
    if (err.status === HttpStatus.INTERNAL_SERVER_ERROR || err.status === HttpStatus.NOT_IMPLEMENTED || err.status === HttpStatus.BAD_GATEWAY) {
      this.getPositionsError = true;
      this.isLoaded = true;
    }
    this.selectPosition(NO_POSITION);
  }

  selectPosition(position) {
    if (position === NO_POSITION) {
      this.specializationsServ.selectedPositionId = '';
      this.specializationsServ.selectedPositionName = NO_POSITION;
    } else {
      this.specializationsServ.selectedPositionId = position.id;
      this.specializationsServ.selectedPositionName = position.name;
    }
  }

  createSpecGroup() {
    this.startOperation();
    const group = this.buildGroupObject();
    this.adminService.createSpecGroup(group).subscribe(
      (response: any) => this.handleCreateSuccess(response),
      () => this.handleCreateError()
    );
  }

  private startOperation() {
    this.inProgress = true;
    this.specializationsServ.createSpecSuccess = false;
  }

  private buildGroupObject() {
    return {
      name: this.specGroupName,
      position: {
        id: this.specializationsServ.selectedPositionId,
        name: this.specializationsServ.selectedPositionName
      }
    };
  }

  private handleCreateSuccess(response: any) {
    if (response.status === HttpStatus.OK) {
      this.specializationsServ.updateTree();
      this.specializationsServ.clearNodeSelection();
      this.operationSuccess = true;
      this.inProgress = false;
    }
  }

  private handleCreateError() {
    this.operationFail = true;
    this.inProgress = false;
  }

  createSubSpecGroup() {
    this.startOperation();
    const group = this.buildGroupObject();
    if (this.specializationsServ.selectedPositionName === NO_POSITION) {
      group.position = null;
    }
    this.adminService.createSubSpecGroup(group, this.specializationsServ.nodeId).subscribe(
      (response: any) => this.handleCreateSuccess(response),
      () => this.handleCreateError()
    );
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/common/specializations/components/add-new-group/add-new-group.component.ts